import React from "react";
import { useNavigate } from "react-router-dom";
import "./styles/Partners.css";

// 1) Put your logos in: src/assets/partners/
// 2) Update these imports to match your filenames
import microsoftLogo from "../../assets/images/partners/microsoft.png";
import logoaws from "../../assets/images/partners/aws.png";

// Example imports (replace with your actual list from Logos-1.docx exports)
import logozoom from "../../assets/images/partners/Zoom-224.png";
import logofive9 from "../../assets/images/partners/Five9.png";
import logoNice from "../../assets/images/partners/NICE-1.png";
import logoLumen from "../../assets/images/partners/Lumen.png";
import logoCisco from "../../assets/images/partners/cisco.webp";
import logo8x8 from "../../assets/images/partners/8x8.webp";
import logoKeeper from "../../assets/images/partners/Keeper-Security.png";
import logohiya from "../../assets/images/partners/Hiya.png";
import logoflexential from "../../assets/images/partners/Flexential.png";
import logounisys from "../../assets/images/partners/unisys-01.png.webp";
import logoRing from "../../assets/images/partners/RingCentral.png";
import logoSangoma from "../../assets/images/partners/sangoma-sp.webp";
import logoCloudflare from "../../assets/images/partners/Cloudflare.png";
import logoSilverSky from "../../assets/images/partners/SilverSky-1.png";
import logoTrustwave from "../../assets/images/partners/Trustwave.png";
import logoVonage from "../../assets/images/partners/Vonage.png";
import logoconvergia from "../../assets/images/partners/convergia-purple.png.webp";
import logocommandlink from "../../assets/images/partners/commandLink-01.png.webp";
import logocogent from "../../assets/images/partners/cogent-01.png.webp";
import logoClaro from "../../assets/images/partners/Claro-1.png.webp";
import logoC3Complete from "../../assets/images/partners/c3cloud-sp.webp";
import breezeline from "../../assets/images/partners/Breezeline-01.png.webp";
import blue from "../../assets/images/partners/Blue-Stream-01.png.webp";
import akamai from "../../assets/images/partners/Akamai-463.png";
import viasat from "../../assets/images/partners/viasat.webp";
import Spectrotel from "../../assets/images/partners/Spectrotel.png";
import RapidScale from "../../assets/images/partners/RapidScale.png";
import Quest from "../../assets/images/partners/Quest.png";
import Perimeter from "../../assets/images/partners/Perimeter81_01T-Single-Page-482.png";
import logoopen from "../../assets/images/partners/Open-Systems.png";
import Ooma from "../../assets/images/partners/ooma-sp.webp";
import nextiva from "../../assets/images/partners/nextiva.webp";
import Comcastmasery from "../../assets/images/partners/masergy-logo-01.webp";
import lastpass from "../../assets/images/partners/lastpass-sp.webp";
import kaspersky from "../../assets/images/partners/kaspersky-sp.webp";
import ionos from "../../assets/images/partners/IONOS-sp.webp";
import HCL from "../../assets/images/partners/hcl-tech-sp.webp";
import Goto from "../../assets/images/partners/Goto-315.png";
import GFI from "../../assets/images/partners/gfi-software-sp.webp";
import Fusion from "../../assets/images/partners/fusion-logo-01.png.webp";
import Frontier from "../../assets/images/partners/frontier-01.png.webp";
import For2Fi from "../../assets/images/partners/For2Fi.png.webp";
import FiberLight from "../../assets/images/partners/fiberlight-01.png.webp";
import Everbridge from "../../assets/images/partners/Everbridge.png.webp";
import Equinix from "../../assets/images/partners/Equinix-1.png.webp";
import Epic from "../../assets/images/partners/epic-io-01.png.webp";
import DirectV from "../../assets/images/partners/Directv-01.png.webp";
import dialpad from "../../assets/images/partners/Dialpad-1.png.webp";
import COX from "../../assets/images/partners/Cox-Business-488.png";
import CORO from "../../assets/images/partners/Coro.png";
import Coresite from "../../assets/images/partners/coresite-logo-01.png.webp";
import Verizon from "../../assets/images/partners/verizon.jpg";
import ComCast from "../../assets/images/partners/corporate_Official-Comcast-Logo.png";



const Partners = () => {
  const navigate = useNavigate();

  const topPartners = [
    { name: "AmazonWebServices", logo: logoaws },
    { name: "Microsoft", logo: microsoftLogo },
  ];

  const partners = [
    { name: "Zoom", logo: logozoom },
    { name: "Five 9", logo: logofive9 },
    { name: "NICE", logo: logoNice },
    { name: "Lumen", logo: logoLumen },
    { name: "Cisco", logo: logoCisco },
    { name: "8x8", logo: logo8x8 },
    { name: "Keeper security", logo: logoKeeper },
    { name: "hiya", logo: logohiya },
    { name: "flexential", logo: logoflexential },
    { name: "unisys", logo: logounisys },
    { name: "ring central", logo: logoRing },
    { name: "Sangoma", logo: logoSangoma },
    { name: "Cloudflare", logo: logoCloudflare },
    { name: "SilverSky", logo: logoSilverSky },
    { name: "Trustwave", logo: logoTrustwave },
    { name: "Vonage", logo: logoVonage },
    { name: "convergia", logo: logoconvergia },
    { name: "command link", logo: logocommandlink},
    { name: "cogent", logo: logocogent},
    { name: "Claro", logo: logoClaro},
    { name: "C3 Complete", logo: logoC3Complete},
    { name: "breezeline", logo: breezeline},
    { name: "blue Stream fiber", logo: blue},
    { name: "akamai", logo: akamai},
    { name: "viasat", logo: viasat},
    { name: "Spectrotel", logo: Spectrotel},
    { name: "RapidScale", logo: RapidScale},
    { name: "Quest", logo: Quest},
    { name: "Perimeter 81", logo: Perimeter},
    { name: "open systems", logo: logoopen},
    { name: "Ooma", logo: Ooma},
    { name: "nextiva", logo: nextiva},
    { name: "Comcast business Masery", logo: Comcastmasery},
    { name: "lastpass", logo: lastpass},
    { name: "kaspersky", logo: kaspersky},
    { name: "ionos", logo: ionos},
    { name: "HCL Tech", logo: HCL},
    { name: "Goto", logo: Goto},
    { name: "GFI software", logo: GFI},
    { name: "Fusion connect", logo: Fusion},
    { name: "Frontier", logo: Frontier},
    { name: "For2Fi", logo: For2Fi},
    { name: "FiberLight", logo: FiberLight},
    { name: "Everbridge", logo: Everbridge},
    { name: "Equinix", logo: Equinix},
    { name: "Epic IO", logo: Epic},
    { name: "DirectV", logo: DirectV},
    { name: "dialpad", logo: dialpad},
    { name: "COX business", logo: COX},
    { name: "CORO", logo: CORO},
    { name: "Coresite", logo: Coresite},
    { name: "Verizon", logo: Verizon},
    { name: "ComCast", logo: ComCast},

    
  ];

  return (
    <div className="partnersPage">
     
      {/* SECTION 3: Dark split hero */}
      <section className="partnersSplit">
        <div className="partnersSplit__left">
          <p className="partnersKicker">OUR PARTNERS</p>
          <h2 className="partnersSplit__title">
            Digital Transformation
            <br />
            Begins with the Right
            <br />
            Partnerships
          </h2>
          <p className="partnersSplit__text">
            We partner with proven technology leaders to deliver advanced solutions that support modern IT
            environments across networking, cloud, and cybersecurity.
          </p>
        </div>

        <div className="partnersSplit__right" />
      </section>
      {/* SECTION 2: Our Partners (light) */}
      <section className="partnersLight">
        <div className="partnersContainer">
          <h2 className="partnersH2">Our Partners</h2>

          <div className="partnersTopGrid">
            {topPartners.map((p) => (
              <article key={p.name} className="partnerCard">
                <div className="partnerCard__logoWrap">
                  <img className="partnerCard__logo" src={p.logo} alt={p.name} />
                </div>

                <div className="partnerCard__meta">
                  <p className="partnerCard__name">{p.name}</p>
                  <span className="partnerCard__arrow">▶</span>
                  <span className="partnerCard__underline" />
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>


      {/* SECTION 4: Logo grid (light) */}
      <section className="partnersGridSection">
        <div className="partnersContainer">
          <div className="partnersRule" />
          <div className="partnersGrid">
            {partners.map((p) => (
              <article key={p.name} className="logoTile">
                <div className="logoTile__box">
                  <img className="logoTile__img" src={p.logo} alt={p.name} />
                </div>
                <div className="logoTile__footer">
                  <span className="logoTile__name">{p.name.toUpperCase()}</span>
                  <span className="logoTile__cta">
                    <span className="logoTile__arrow">▶</span>
                    <span className="logoTile__line" />
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
      {/* SECTION 1: LET'S MEET banner */}
      <section className="partnersMeet">
        <div className="partnersMeet__overlay" />
        <div className="partnersMeet__content">
          <h1 className="partnersMeet__title">Let’s Meet</h1>
          <p className="partnersMeet__text">
            For more information about working with Com Networks, give us a call or send us an email.
            We’re here to help in any way.
          </p>
          <button className="partnersBtn partnersBtn--orange" onClick={() => navigate("/contact")}>
            ENGAGE WITH AN EXPERT
          </button>
        </div>
      </section>
    </div>
  );
};

export default Partners;
